// Small helper to detect Capacitor native runtime without importing @capacitor/core
// on the web path (avoids issues when Capacitor is not initialized in a plain web build).

export const isNativeApp = () => {
  if (typeof window === 'undefined') return false;
  // Capacitor sets window.Capacitor with isNativePlatform() at runtime
  return Boolean(window.Capacitor?.isNativePlatform?.());
};

export const getCapacitorPlatform = () => {
  if (typeof window === 'undefined') return 'web';
  return window.Capacitor?.getPlatform?.() || 'web';
};
